import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="mt-9">
    <h2 className="font-display text-xl md:text-2xl font-bold text-white tracking-tight">{title}</h2>
    <div className="mt-3 space-y-3 text-[#B4B4B4] text-sm md:text-base leading-relaxed">{children}</div>
  </section>
);

export default function StudioTimePrivacy() {
  return (
    <div className="grain min-h-screen relative bg-[#0A0A0A]" data-testid="studiotime-privacy-page">
      {/* Header */}
      <header className="border-b border-white/10 bg-black/70 backdrop-blur-2xl">
        <div className="px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Ceinaru Media" className="h-9 w-9" />
            <span className="font-display font-extrabold text-xl tracking-tight">CEINARU<span className="text-[#D90429]"> MEDIA</span></span>
          </Link>
          <a href="https://www.ceinarumedia.ro" className="text-xs uppercase tracking-[0.15em] text-[#A0A0A0] hover:text-white transition-colors">ceinarumedia.ro</a>
        </div>
      </header>

      <main className="px-6 md:px-12 lg:px-20 py-14 md:py-20 relative z-10">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D90429] mb-4">Studio Time · Legal</p>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter text-white">Privacy Policy for Studio Time</h1>
          <p className="mt-4 text-sm text-[#808080]">Last updated: September 14, 2026</p>

          <p className="mt-8 text-[#B4B4B4] text-sm md:text-base leading-relaxed">
            Studio Time is a studio-session time-tracking application developed by <strong className="text-white">Ceinaru Media</strong>.
          </p>

          <Section title="Information stored by the app">
            <p>StudioTime stores the following information locally on your device:</p>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Saved hourly rates.</li>
              <li>Selected currencies.</li>
              <li>Session start, pause, and stop times.</li>
              <li>Session duration and calculated amounts.</li>
              <li>Session history.</li>
              <li>PDF session reports generated by the app.</li>
            </ul>
            <p>
              Studio Time does not require an account and does not collect your name, email address, contacts, location,
              photos, microphone recordings, or payment information.
            </p>
          </Section>

          <Section title="How your data is used">
            <p>
              The locally stored information is used only to calculate studio-session costs, display session history, and
              generate PDF session reports.
            </p>
          </Section>

          <Section title="Audio, camera, location, contacts, and other sensitive permissions">
            <p>
              Studio Time does not access the microphone, camera, location, contacts, or photos unless a future version
              clearly requests and explains such access.
            </p>
          </Section>

          <Section title="Sharing and disclosure">
            <p>
              StudioTime does not upload or sell your session data. Session PDFs remain under your control. If you choose to
              share or save a PDF using Android’s sharing features, the file is sent to the app or service you select.
            </p>
          </Section>

          <Section title="Internet access">
            <p>
              Studio Time is designed to work without an internet connection and does not transmit your locally stored
              session data to a remote server.
            </p>
          </Section>

          <Section title="Data retention and deletion">
            <p>
              Your session history, rates, currencies, and settings remain on your device until you delete them in the app or
              uninstall Studio Time. You can delete individual sessions using the app’s delete function, if available.
              Uninstalling the app may remove locally stored app data.
            </p>
            <p>Studio Time does not maintain a remote copy of this information.</p>
          </Section>

          <Section title="Payments and subscriptions">
            <p>
              If StudioTime offers a Google Play subscription or in-app purchase, payment processing is handled by Google Play.
              StudioTime does not receive or store your full payment-card details. Subscription management and refund requests
              are handled through Google Play, subject to Google Play’s policies.
            </p>
          </Section>

          <Section title="Children’s privacy">
            <p>
              StudioTime is not directed specifically to children and does not knowingly collect personal information from
              children.
            </p>
          </Section>

          <Section title="Security">
            <p>
              Because Studio Time stores session information locally, protect your device with the security features provided
              by your operating system.
            </p>
          </Section>

          <Section title="Changes to this policy">
            <p>
              This privacy policy may be updated when Studio Time’s features or data practices change. The latest version will
              be published on this page.
            </p>
          </Section>

          <Section title="Contact">
            <p>For privacy questions or support, contact:</p>
            <p className="text-white">
              Email:{" "}
              <a href="mailto:ceinaru@icloud.com" className="text-[#D90429] hover:underline" data-testid="privacy-support-email">
                ceinaru@icloud.com
              </a>
              <br />
              Website:{" "}
              <a href="https://www.ceinarumedia.ro" className="text-[#D90429] hover:underline">
                https://www.ceinarumedia.ro
              </a>
            </p>
          </Section>

          <div className="mt-14 pt-8 border-t border-white/10 text-xs text-[#666]">
            © {new Date().getFullYear()} Ceinaru Media. Studio Time.
          </div>
        </div>
      </main>
    </div>
  );
}
